const RouteService = function () {
    this.intendedRoute = {
        to: '',
        params: {}
    };

    this.aemRoute = {};

    return {
        intendedRoute: this.intendedRoute,
        aemRoute: this.aemRoute
    };
};

module.exports = RouteService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/route/route-service.js
 **/